// Side-effects that must follow the active i18next language but are NOT string
// lookups: date libraries, and the <html lang> attribute.
//
// Kept separate from i18n/index.js so the date wiring can be reasoned about (and
// disabled) on its own — see I18N_PLAN.md risk 4.2.
import moment from 'moment';
import 'moment/locale/ms';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { ms as msDateFns, enUS as enDateFns } from 'date-fns/locale';

// Set to false to keep all moment/react-datepicker output in English even when
// the UI is switched to Malay (e.g. if 'DD-MMM-YYYY' must stay "29-Aug-2026"
// rather than becoming "29-Ogs-2026").
export const LOCALIZE_DATES = true;

registerLocale('en', enDateFns);
registerLocale('ms', msDateFns);

export const normalizeLng = (lng) => (String(lng || '').toLowerCase().startsWith('ms') ? 'ms' : 'en');

export const applyLocale = (lng) => {
  const code = normalizeLng(lng);

  // <html lang> — screen readers and browser translation prompts read this.
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', code);
  }

  const dateCode = LOCALIZE_DATES ? code : 'en';
  moment.locale(dateCode);
  setDefaultLocale(dateCode);
};
